// test624
(624 && 0);
